import { ROOT_ID, podNodeId, serviceNodeId } from './graphModel';

const SEPARATOR = ',';
const SERVICE_PREFIX = serviceNodeId('');
const POD_PREFIX = podNodeId('');

/** The open path as the URL holds it (`path=service:a,pod:b`), cluster excluded. */
export const parsePath = (param: string | null | undefined) =>
  param ? param.split(SEPARATOR).filter(Boolean) : [];

export const serializePath = (ids: string[]) =>
  ids.filter(id => id !== ROOT_ID).join(SEPARATOR);

/**
 * Pods a path names, by the service they sit under, so that service's page is asked to include them:
 * a pod reached by search or a link may sort past the first page.
 */
export function pinnedPods(path: string[]) {
  const pins = new Map<string, string[]>();
  let service: string | null = null;
  path.forEach(id => {
    if (id.startsWith(SERVICE_PREFIX)) service = id.slice(SERVICE_PREFIX.length);
    else if (id.startsWith(POD_PREFIX) && service) {
      pins.set(service, [...(pins.get(service) ?? []), id.slice(POD_PREFIX.length)]);
    }
  });
  return pins;
}
